export default __webpack_public_path__ + "static/media/applestore.66df2301.svg";